import React from 'react';
import Services from '../components/Services';

const ServicesPage = () => {
  return (
    <main className="pt-20">
      <Services />
    </main>
  );
};

export default ServicesPage;
